export default "__VITE_ASSET__CEdBX8C5__"